import {secureFetch} from "./authService";
import {API_BASE_URL} from "./constants";

export function getMaxNumberOfLoanPayments(query) {
    const {integration, retailerId, pointId} = query;

    let url = API_BASE_URL + `/loan/retailer/property/maxNumberOfPayments` +
        `?integration=${integration}&retailerId=${retailerId}&pointId=${pointId}`;

    return secureFetch(url, {
        method: 'GET',
    });
}

export function saveLoanRetailerProperty(property) {
    return secureFetch(API_BASE_URL + `/loan/retailer/property`, {
        method: 'POST',
        body: JSON.stringify(property)
    });
}

export function updateLoanRetailerProperty(property) {
    return secureFetch(API_BASE_URL + `/loan/retailer/property/${property.id}`, {
        method: 'PUT',
        body: JSON.stringify(property)
    });
}


// WEBPACK FOOTER //
// ./src/helpers/loanRetailerPropertyService.js